module.exports = __webpack_public_path__ + "img/serviceGuide-business-2.fa861ae.png";